import { useNavigate } from 'react-router-dom';
import { Dialog as ShadcnDialog, DialogContent } from '@e2n/ui';
import { EditForm } from './EditForm';
import { Suspense, useState } from 'react';
import { FallbackDialogContent } from './FallbackDialogContent';
import { DialogContextProvider } from './DialogContext';
import { ConfirmDialog } from '../../components/ConfirmDialog';
import { useRouteParams } from './useRouteParams';
import dayjs from 'dayjs';

export function Dialog() {
  const navigate = useNavigate();
  const [hasFormUnsavedChanges, setHasFormUnsavedChanges] = useState(false);
  const [isConfirmDialogVisible, setIsConfirmDialogVisible] = useState(false);
  const { routeParams } = useRouteParams();

  function onHandleClose(open: boolean) {
    if (!open && hasFormUnsavedChanges) {
      setIsConfirmDialogVisible(true);
    } else {
      navigate(
        `/controlling/umsatzplanung/${routeParams.jahr}/${routeParams.monat}`,
        {
          replace: true,
        },
      );
    }
  }

  return (
    <>
      <ConfirmDialog
        open={isConfirmDialogVisible}
        onOpenChange={setIsConfirmDialogVisible}
        redirectTo={{
          jahr: routeParams.jahr ?? dayjs().get('year'),
          monat: routeParams.monat ?? dayjs().get('month') + 1,
        }}
        type="ziele"
      />
      <ShadcnDialog
        key="edit-ziele-dialog"
        open={true}
        onOpenChange={onHandleClose}>
        <DialogContent className="sm:max-w-[680px] px-8 py-0">
          <Suspense fallback={<FallbackDialogContent />}>
            <DialogContextProvider>
              <EditForm setHasChanges={setHasFormUnsavedChanges} />
            </DialogContextProvider>
          </Suspense>
        </DialogContent>
      </ShadcnDialog>
    </>
  );
}
